<script>
	import Papa from "papaparse";

	let totalVaccinations = 0;

	// URL of the CSV file — the per-disease dataset; the older combined
	// immunization_doses_v202310.csv stopped being updated in May 2026.
	const csvUrl =
		"https://opendata-files.sozialversicherung.at/eimpfpass/impfdatenat_covid19_v202601.csv?q=now";

	// Monday of the given ISO week. Everything is computed in UTC and
	// compared against a UTC season start, so the result never depends on
	// the visitor's time zone. Mixing local dates with a UTC-parsed cutoff
	// used to silently drop the first week whenever it started on the 1st.
	function getDateFromWeek(year, week) {
		const monday = new Date(Date.UTC(year, 0, 1 + (week - 1) * 7));
		const dow = monday.getUTCDay();
		monday.setUTCDate(monday.getUTCDate() + (dow <= 4 ? 1 - dow : 8 - dow));
		return monday;
	}

	// Start of the vaccination season. The open data is weekly, so this is
	// the Monday of the week containing 1 September.
	const seasonStart = new Date("2026-08-31");

	// Load and process the CSV data
	Papa.parse(csvUrl, {
		download: true,
		header: true,
		complete: (results) => {
			// Filter records for COVID-19 and from the start of the 2026/27 season onwards
			const filteredData = results.data.filter((row) => {
				const year = parseInt(row["year"], 10);
				const week = parseInt(row["week"], 10);

				// Skip if year/week is invalid. The dataset is COVID-19-only,
				// so there is no immunization_target column to filter on.
				if (isNaN(year) || isNaN(week)) {
					return false;
				}

				// Convert year and week to a date
				const date = getDateFromWeek(year, week);

				// Check if the week falls into the current season
				return date >= seasonStart;
			});

			// Sum up the doses administered
			totalVaccinations = filteredData.reduce((sum, row) => {
				const doses = parseInt(row["doses_administered"], 10); // Adjust if needed
				return sum + (isNaN(doses) ? 0 : doses);
			}, 0);
		},
		error: (err) => {
			console.error("Error parsing CSV:", err);
		},
	});
</script>

{#if totalVaccinations > 0}
	<div class="md:flex md:space-x-4">
		<p class="text-6xl font-light">
			{totalVaccinations.toLocaleString("de-DE")}
		</p>
		<div class="">
			<p>im e-Impfpass dokumentierte Impfungen seit 31. August 2026</p>
			<p class="underline underline-offset-4 opacity-70">
				<a href="https://impfdaten.at">Impfdaten-Dashboard</a>
			</p>
		</div>
	</div>
{/if}
